import React, {useEffect, useRef, useState} from 'react';
import {Button, Modal, Result, Tooltip} from 'antd';
import {SmileOutlined} from "@ant-design/icons";
import {userGetGalleryInviteCode} from "../../api/user";
import HttpError from "../base/HttpError";
import {Skeleton} from "antd/es";

export default function (props) {
    const [open, setOpen] = useState(false);
    const [loadingData, setLoadingData] = useState(false)
    const [code, setCode] = useState(null)
    const [copyOpen, setCopyOpen] = useState(false)
    const urlRef = useRef(null);

    useEffect(() => {
        setOpen(props.open)
        if(props.open) {
            setLoadingData(true)
            userGetGalleryInviteCode().then((res)=>{
                setCode(res.data.artist_invite_code)
            }).catch((e)=>{
                HttpError(e)
            }).finally(()=>{
                setLoadingData(false)
            })
        }

    }, [props.open])

    const showModal = () => {
        setOpen(true);
        props.onClose()
    };
    const hideModal = () => {
        setOpen(false);
        props.onClose()
    };

    const url = 'https://revart.co/sam/signup?type=artist&invite_code='+(code)

    const handleCopy = () => {
       navigator.clipboard.writeText(url).then(() => {
            setCopyOpen(true)
            /* Resolved - text copied to clipboard successfully */
        }, () => {
            /* Rejected - text failed to copy to the clipboard */
        });
    };

    return <>
        <Modal title="Invite your artists" open={open} onOk={hideModal} onCancel={hideModal}>
            {loadingData && (
                <Skeleton/>
            )}
            {!loadingData && code && (
                <Result
                    icon={<SmileOutlined />}
                    subTitle="Use the specific signup link below for your gallery artists signup:"
                    children={<a target={'_blank'} ref={urlRef} href={url}>{url}</a>}
                    extra={<Tooltip open={copyOpen} title={'URL copied. Ready to share!'}>
                        <Button type="primary" onClick={handleCopy}>Copy</Button> </Tooltip>}
                  />
            )}
        </Modal>
    </>
}